// --------------------------- BASE URLS --------------------------------------
export const BackendUrl = process.env.NEXT_PUBLIC_BASE_URL!;
export const BaseUrl = BackendUrl + "v2";
export const BucketUrl = process.env.NEXT_PUBLIC_BUCKET_URL!;

// --------------------------- API ROUTES -------------------------------------
export const api = {
  // --------------------------- AUTH -----------------------------------------
  Signup: "auth/signup",
  Login: "auth/signin",
  get_login_user_details: "auth/get_login_user_details",
  generate_refresh_token: "auth/generate_refresh_token",
  verify_OTP: "auth/verify_OTP",
  resend_OTP: "auth/resend_OTP",
  reset_password: "auth/reset_password",
  change_password: "auth/change_password",
  request_password_reset: "auth/request_password_reset",
  request_delete_user: "auth/request_delete_user",
  delete_account: "auth/delete_account",
  getSkills: "common/getSkills",
  get_all_user_by_type: "auth/get_all_user_by_type",
  get_user_by_id: "auth/get_user_by_id",
  update_profile: "auth/update_profile",
  get_customer_fields: "auth/get_customer_fields",
  update_customer_fields: "auth/update_customer_fields",
  get_location_from_zipcode: "auth/get_location_from_zipcode",
  update_driver_version: "auth/update_driver_version",
  update_mealy_version: "auth/update_mealy_version",
  get_mealy_version: "auth/get_mealy_version",
  save_subscription: "auth/save_subscription",
  manage_address: "auth/manage_address",
  update_preference_and_restriction: "auth/update_preference_and_restriction",
  // --------------------------- FILE UPLOAD ----------------------------------
  FileUpload: "upload/image/food",
  FilesUpload: "upload/images/food",

  // --------------------------- MENU : CATEGORY ------------------------------
  create_category: "menu/create_category",
  update_category: "menu/update_category",
  delete_category: "menu/delete_category",
  get_all_category: "menu/get_all_category",

  // --------------------------- MENU : MAIN DISH -----------------------------
  create_main_dish: "menu/create_main_dish",
  update_main_dish: "menu/update_main_dish",
  delete_main_dish: "menu/delete_main_dish",
  get_main_dish_by_id: "menu/get_main_dish_by_id",
  get_all_main_dishes: "menu/get_all_main_dishes",
  update_main_dish_fields: "menu/update_main_dish_fields",
  get_main_dish_fields: "menu/get_main_dish_fields",
  get_all_main_dish_by_category_id: "menu/get_all_main_dish_by_category_id",
  bulk_update_main_dish: "menu/bulk_update_main_dish",

  // --------------------------- MENU : SIDES ---------------------------------
  create_side: "menu/create_side",
  update_side: "menu/update_side",
  delete_side: "menu/delete_side",
  get_side_by_id: "menu/get_side_by_id",
  get_all_sides: "menu/get_all_sides",
  update_side_fields: "menu/update_side_fields",
  get_side_fields: "menu/get_side_fields",
  bulk_update_side: "menu/bulk_update_sides",

  // --------------------------- MENU : DRINKS --------------------------------
  create_drink: "menu/create_drink",
  update_drink: "menu/update_drink",
  delete_drink: "menu/delete_drink",
  get_drink_by_id: "menu/get_drink_by_id",
  get_all_drinks: "menu/get_all_drinks",
  update_drink_fields: "menu/update_drink_fields",
  get_drink_fields: "menu/get_drink_fields",
  bulk_update_drink: "menu/bulk_update_drinks",

  // --------------------------- MENU : SCHEDULE (v2) -------------------------
  add_menu_schedule: "order/add_menu_schedule",
  update_menu_schedule: "order/update_menu_schedule",
  get_weekly_menu: "order/get_weekly_menu",
  get_scheduled_menu_by_date: "order/get_scheduled_menu_by_date",
  // == ORDER (v2) ==
  get_orders_by_status: "order/get_orders_by_status",
  get_orders_in_cart: "order/get_orders_in_cart",
  get_order_details_for_dashboard: "order/get_order_details_for_dashboard",
  get_order_box_label_details: "order/get_order_box_label_details",
  update_order_status: "order/update_order_status",
  update_box_item_status: "order/update_box_item_status",
  pickup_order: "order/pickup_order",
  // == Day View (v2) ==
  get_scheduled_main_dishes_by_date: "order/get_scheduled_main_dishes_by_date",
  get_scheduled_sides_by_date: "order/get_scheduled_sides_by_date",
  get_scheduled_drinks_by_date: "order/get_scheduled_drinks_by_date",
  // == Meal Session Config (v2) ==
  get_all_meal_session_config: "order/get_all_meal_session_config",
  create_meal_session_config: "order/create_meal_session_config",
  update_meal_session_config: "order/update_meal_session_config",
  toggle_meal_session_config: "order/toggle_meal_session_config",

  get_meal_session_effective_dates: "order/get_meal_session_effective_dates",
  get_all_time_slot_config: "order/get_all_time_slot_config",
  create_time_slot_config: "order/create_time_slot_config",
  update_time_slot_config: "order/update_time_slot_config",

  // --------------------------- PREFERENCE & DIETARY -------------------------
  get_preference_and_restriction_by_type: "menu/get_preference_and_restriction_by_type",
  create_preference: "menu/create_preference",
  create_restriction: "menu/create_restriction",
  delete_preference: "menu/delete_preference",
  delete_restriction: "menu/delete_restriction",
  get_all_preference_and_restriction_types: "menu/get_all_preference_and_restriction_types",
  create_preference_and_restriction_type: "menu/create_preference_and_restriction_type",
  delete_preference_and_restriction_type: "menu/delete_preference_and_restriction_type",
  update_preference_and_restriction_type: "menu/update_preference_and_restriction_type",

  // --------------------------- KITCHEN --------------------------------------
  create_kitchen: "driver/create_kitchen",
  update_kitchen: "driver/update_kitchen",
  delete_kitchen: "driver/delete_kitchen",

  // --------------------------- AGENCY ---------------------------------------
  create_agency: "driver/create_agency",
  update_agency: "driver/update_agency",
  delete_agency: "driver/delete_agency",
  get_agency_fields: "driver/get_agency_fields",
  update_agency_fields: "driver/update_agency_fields",

  // --------------------------- DRIVER ---------------------------------------
  create_driver: "driver/create_driver",
  update_driver: "driver/update_driver",
  delete_driver: "driver/delete_driver",
  get_all_driver: "driver/get_all_driver",
  get_kitchen_fields: "driver/get_kitchen_fields",
  update_kitchen_fields: "driver/update_kitchen_fields",
  get_driver_fields: "driver/get_driver_fields",
  update_driver_fields: "driver/update_driver_fields",
  get_driver_version: "driver/get_driver_version",
  // --------------------------- SETTINGS -------------------------------------
  create_policy: "setting/create_policy",
  update_policy: "setting/update_policy",
  get_all_policy: "setting/get_all_policies",
  active_inActive_policy: "setting/active_inActive_policy",
  get_policy_by_code: "setting/get_policy_by_code",
  create_mail_template: "setting/create_mail_template",
  update_mail_template: "setting/update_mail_template",
  get_all_mail_template: "setting/get_all_mail_template",
  get_mail_template_by_id: "setting/get_mail_template_by_id",
  send_template_mail: "setting/send_template_mail",
  create_notification_template: "setting/create_notification_template",
  update_notification_template: "setting/update_notification_template",
  get_all_notification_template: "setting/get_all_notification_template",
  get_notification_template_by_id: "setting/get_notification_template_by_id",
  send_template_notification: "setting/send_template_notification",
  create_imp_link: "setting/create_imp_link",
  update_imp_link: "setting/update_imp_link",
  get_all_imp_link: "setting/get_all_imp_link",
  get_imp_link_by_id: "setting/get_imp_link_by_id",

  // --------------------------- NOTIFICATION MANAGER -------------------------
  get_notification_manager_summary: "setting/notification_manager/summary",
  get_all_notification_definitions: "setting/notification_manager/get_all_definitions",
  get_notification_definition: "setting/notification_manager/get_definition",
  create_notification_definition: "setting/notification_manager/create_definition",
  update_notification_definition: "setting/notification_manager/update_definition",
  toggle_notification_definition: "setting/notification_manager/toggle_definition",
  get_all_notifications: "setting/get_all_notifications",
  delete_notifications: "setting/delete_notifications",

  // --------------------------- COUPONS --------------------------------------
  create_coupon: "coupon/create_coupon",
  update_coupon: "coupon/update_coupon",
  delete_coupon: "coupon/delete_coupon",
  get_coupon_by_id: "coupon/get_coupon_by_id",
  get_all_coupons: "coupon/get_all_coupons",

  // --------------------------- ORDERS (v2) ------------------------------------
  assign_orders_to_agency: "order/assign_orders_to_agency",
  get_admin_confirmed_orders: "order/get_admin_confirmed_orders",
  get_admin_pending_orders: "order/get_admin_pending_orders",
  get_agency_assigned_pending_orders: "order/get_agency_assigned_pending_orders",
  get_agency_assigned_confirmed_orders: "order/get_agency_assigned_confirmed_orders",
  assign_orders_to_driver: "order/assign_orders_to_driver",
  get_agency_assigned_kitchens: "order/get_agency_assigned_kitchens",
  cancel_order: "order/cancel_order",
  scheduled_order: "order/scheduled_order",
  get_rejected_orders: "order/get_rejected_orders",
  admin_kitchen_order_history: "order/admin_kitchen_order_history",
  admin_kitchen_get_order_by_id: "order/admin_kitchen_get_order_by_id",
  get_replacement_candidates: "order/get_replacement_candidates",
  propose_order_replacement: "order/propose_order_replacement",
  get_admin_replacement_order_list: "order/get_admin_replacement_order_list",

  // --------------------------- SUPPORTS -------------------------------------
  get_all_tickets: "setting/get_all_tickets",
  get_ticket_counts: "setting/get_ticket_counts",
  get_help_desk_ticket_by_id: "setting/get_help_desk_ticket_by_id",
  request_support: "setting/request_support",
  response_support: "setting/response_support",
  add_ticket_message: "setting/add_ticket_message",
  process_refund_ticket: "setting/process_refund_ticket",

  // --------------------------- VACATION MODE (v2) -----------------------------
  create_vacation_offer: "vacation/create_vacation_offer",
  update_vacation_offer: "vacation/update_vacation_offer",
  get_all_vacation_offers: "vacation/get_all_vacation_offers",
  toggle_vacation_offer: "vacation/toggle_vacation_offer",
  get_users_on_vacation: "vacation/get_users_on_vacation",

  // --------------------------- EVENTS (OFFERS) ------------------------------
  create_event: "event/create_event",
  update_event: "event/update_event",
  get_all_events: "event/get_all_events",
  get_event_by_id: "event/get_event_by_id",
  delete_event: "event/delete_event",

  // == Meal Day Closure / Holiday (v2) ==
  meal_day_closure_calendar: "order/meal_day_closure_calendar",
  meal_day_closure_toggle: "order/meal_day_closure_toggle",
  meal_day_closure_all_holiday: "order/meal_day_closure_all_holiday",
  meal_day_closure_preview: "order/meal_day_closure_preview",
  meal_day_closure_save: "order/meal_day_closure_save",
  meal_day_closures: "order/meal_day_closures",
  get_kitchen_replacement_limits_config: "order/get_kitchen_replacement_limits_config",
  create_update_kitchen_replacement_limits_config:"order/create_update_kitchen_replacement_limits_config",
};

